import React from "react";
import { asHex, position } from "../svg-helpers";

export default (props) => {
  const { opacity, fill } = props;
  return <rect fill={asHex(fill)} opacity={opacity} {...position(props)} />;
};
